import { render, staticRenderFns } from "./FaceRecognitionCamera.vue?vue&type=template&id=8472d54e&scoped=true"
import script from "./FaceRecognitionCamera.vue?vue&type=script&lang=js"
export * from "./FaceRecognitionCamera.vue?vue&type=script&lang=js"
import style0 from "./FaceRecognitionCamera.vue?vue&type=style&index=0&id=8472d54e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8472d54e",
  null
  
)

export default component.exports